/*@flow*/
import set from './set';
export default (path: string): void => {
  const updater = v => (v && v.clear ? v.clear() : undefined);
  return set(path, updater);
};
